<template>
  <div class="toggles-card">
    <div class="toggle-row">
      <span class="toggle-row__label">
        {{ label }}
        <small v-if="ajuda" class="toggle-row__help">{{ ajuda }}</small>
      </span>
      <label class="toggle-switch">
        <input
          type="checkbox"
          :checked="!!value"
          :disabled="disabled"
          @change="$emit('input', $event.target.checked)"
        />
        <span class="toggle-slider"></span>
        <span class="toggle-text">{{ value ? 'Sim' : 'Não' }}</span>
      </label>
    </div>
  </div>
</template>

<script>
/*
 * A pergunta de sim ou não como linha com interruptor.
 *
 * Existe porque o mesmo controle estava escrito em duas abas vizinhas da
 * Configuração de IA — mesmo markup, mesmo CSS — e as cópias já tinham
 * divergido no espaçamento e na borda: o mesmo controle se desenhava de dois
 * jeitos na mesma tela.
 */
export default {
  name: 'ToggleSwitch',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    ajuda: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.toggles-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 16px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-row__label {
  font-size: 13px;
  color: #333;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.toggle-row__help {
  font-size: 12px;
  color: #667085;
  font-weight: 400;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
}

.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}

.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}

.toggle-text {
  font-size: 12px;
  color: #667085;
  min-width: 28px;
}
</style>
